import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Store} from '@ngxs/store';
import {GlobalPageElementState} from '@store/global-page-element/global-page-element-state.service';
import {
  UmpireComponentBranding,
  UmpireComponentTypeEnum,
  UmpireGlobalPageElementSlugEnum,
} from '@tisa-group/models';

@Injectable({providedIn: 'root'})
export class TemplatePageTitleStrategy extends TitleStrategy {
  public defaultTitle: string | undefined;

  constructor(
    private readonly title: Title,
    private readonly translateService: TranslateService,
    private readonly store: Store,
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    if (!this.defaultTitle) {
      const globalBranding = this.store.selectSnapshot(
        GlobalPageElementState.getGlobalPageElementBySlug(
          UmpireGlobalPageElementSlugEnum.BRANDING,
        ),
      );
      const branding = globalBranding?.components?.find(
        item => item.kind === UmpireComponentTypeEnum.BRANDING,
      ) as UmpireComponentBranding;

      if (branding?.page_title) {
        this.defaultTitle = branding.page_title;
      }
    }
    let title = this.buildTitle(routerState);

    if (title) {
      title = this.translateService.instant(title);
    }
    const newTitle = [title, this.defaultTitle].filter(Boolean).join(' • ');

    this.title.setTitle(newTitle);
  }
}
